import Login from "./Login";

export default function Register() {
  return <Login mode="register" />;
}
